<main class="main-wrap">
  <div class="middle-wrapper">
    <app-price-component></app-price-component>
  </div>
  <div class="right-sidebar-wrapper">
    <app-price-right-side-bar-page></app-price-right-side-bar-page>
  </div>
</main>
